import { render, staticRenderFns } from "./ReporteAsignacionesPorTrab.vue?vue&type=template&id=84d333cc&scoped=true"
import script from "./ReporteAsignacionesPorTrab.vue?vue&type=script&lang=js"
export * from "./ReporteAsignacionesPorTrab.vue?vue&type=script&lang=js"
import style0 from "./ReporteAsignacionesPorTrab.vue?vue&type=style&index=0&id=84d333cc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "84d333cc",
  null
  
)

export default component.exports